<div class="stepper-wrapper" [ngClass]="{'type-b': templateSuffix !== ''}">
  <div class="stepper-item" *ngFor="let tab of tabs" >
    <div class="step-counter" [ngClass]="{ active: showIfNotMyStep( tab.step ) }">
      <mat-icon *ngIf="showIfNotMyStep( tab.step )"> done </mat-icon>
      <span *ngIf="showIfMyStep( tab.step )"> <strong> {{ tab.step + 1 }} </strong> </span>
    </div>
    <div class="step-name" *ngIf="showIfMyStep( tab.step )">
      <strong> {{ tab.title }} </strong>
      <div class="linea"></div>
    </div>
  </div>
</div>


